import VehicleTripsView from "./views/VehicleTripsView.vue";

const vehicleTripsRoutes = [
    {
        path: '/vehicle-trips',
        component: VehicleTripsView,
        name: 'VehicleTrips',
        meta: { requiresAuth: true },

    }
]

export default router => {
    vehicleTripsRoutes.forEach(route => {
        router.addRoute(route);
    });
}